import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, FormGroup } from '@angular/forms';

@Directive({
  selector: '[appCheckIfAnyFieldHasData]',
  exportAs: 'checkIfAnyFieldHasData',
  providers: [{ provide: NG_VALIDATORS, useExisting: CheckIfAnyFieldHasDataDirective, multi: true }]
})
export class CheckIfAnyFieldHasDataDirective implements Validator {
  @Input() fieldsNotToValidate: string[] = [];

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (control && control.value) {
      const controls = control.value;
      for (const key in controls) {
        if (controls.hasOwnProperty(key) && !this.fieldsNotToValidate.includes(key)) {
          const ctrl = controls[key];
          if (ctrl && ctrl !== null && ctrl !== '' && ctrl !== undefined) {
            return null;
          }
        }
      }
    }

    return { 'noData': true };
  }
}
